import React, { useState, useRef } from "react";
import "./Annuaire.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import AnnuaireEtudiantContainer from "Components/Annuaire/AnnuaireEtudiant/AnnuaireEtudiantContainer/AnnuaireEtudiantContainer";
import Footer from "Components/Footer/Footer";
import AnnuaireEntrepriseContainer from "Components/Annuaire/AnnuaireEntreprise/AnnuaireEntrepriseContainer/AnnuaireEntrepriseContainer";
import AnnuaireAlumniContainer from "Components/Annuaire/AnnuaireAlumni/AnnuaireAlumniContainer/AnnuaireAlumniContainer";
import Header from "Components/Header/Header";

/**
 * Permet d'afficher la page d'annuaire
 */
// TO DO : gestion éditoriale : intégrer la visibilité de l'annuaire, la modification de titre et la visibilité des différents annuaires
const Annuaire = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [activeIndex, setActiveIndex] = useState(0);

  const annuaire = useRef(0);

  function setActiveAnnuaire(i) {
    annuaire.current = i;
  }
  function getComponentWithIndex() {
    switch (props.items.activeItemAnnuaire.label) {
      case "Annuaire étudiants":
        return (
          <AnnuaireEtudiantContainer
            setActiveIndex={setActiveIndex}
            items={props.items.itemsAnnuaire}
            bouton="VOIR TOUS LES ÉTUDIANTS "
            annuaire={annuaire.current}
          />
        );
      case "Annuaire Alumni":
        return (
          <AnnuaireAlumniContainer
            setActiveIndex={setActiveAnnuaire}
            items={props.items.itemsAnnuaire}
            bouton="VOIR TOUS LES ALUMNI "
            activeIndex={annuaire}
          />
        );
      case "Annuaire entreprises":
        return (
          <AnnuaireEntrepriseContainer
            setActiveIndex={setActiveIndex}
            items={props.items.itemsAnnuaire}
            bouton="VOIR TOUTES LES ENTREPRISES "
          />
        );
    }
  }
  return (
    <div className="annuaire">
      {!props.auth.isConnected && <Header />}
      {props.auth.isConnected && getComponentWithIndex()}
      <Footer />
    </div>
  );
};

Annuaire.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Annuaire);
